import { render, staticRenderFns } from "./MedicalRecordPopup.vue?vue&type=template&id=7bd345f3&scoped=true&"
import script from "./MedicalRecordPopup.vue?vue&type=script&lang=ts&"
export * from "./MedicalRecordPopup.vue?vue&type=script&lang=ts&"
import style0 from "./MedicalRecordPopup.vue?vue&type=style&index=0&id=7bd345f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd345f3",
  null
  
)

export default component.exports